







import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class extends Vue {
  @Prop({ required: true })
  src!: string

  get backgroundImage() {
    return `url('${this.src}')`
  }
}
